import './about.css';

export default function About() {
    const images = {
        about1: "images/about1.jpg",
        about2: "images/about2.jpg",
        profile: "images/profilepic.jpg",
        logo: "images/logo/logo1.png"
    }

    return (
        <section id="about" className="about-section py-5">
            <div className="container" data-aos="fade-up">
                <div className="row align-items-center">
                    
                    {/* LEFT: Visual Stack */}
                    <div className="col-lg-6 mb-5 mb-lg-0">
                        <div className="about-image-container">
                            <div className="main-img-wrapper">
                                <img src={images.about1} alt="Innovation" className="img-fluid rounded-custom shadow-lg" />
                                <div className="experience-box">
                                    <h2 className="mb-0">100+</h2>
                                    <p className="mb-0">Projects Delivered</p>
                                </div>
                            </div>
                            <div className="secondary-img-wrapper d-none d-md-block">
                                <img src={images.about2} alt="Teamwork" className="img-fluid rounded-custom shadow-md border-white-large" />
                            </div>
                            <div className="abstract-shape"></div>
                        </div>
                    </div>

                    {/* RIGHT: Content Stack */}
                    <div className="col-lg-6 ps-lg-5">
                        <div className="about-content">
                            <div className="section-intro mb-4">
                                <img src={images.logo} width={200} alt="Logo" className="mb-3" />
                                <h6 className="text-primary-gradient fw-bold text-uppercase ls-2">Digital Excellence</h6>
                                <h2 className="display-6 fw-bold mb-3">Empowering Innovation <span className="text-blue-glow">Through Technology</span></h2>
                                <div className="mission-line"></div>
                            </div>

                            <p className="lead-text mb-4">
                                At <strong>Cyber Software Developers</strong>, we don't just write code; we architect success. We specialize in building scalable, secure, and user-centric digital ecosystems.
                            </p>

                            <div className="row g-3 mb-5">
                                {[
                                    "Custom Web & App Dev",
                                    "UI/UX Modern Trends",
                                    "Scalable Security",
                                    "Client-Centric Approach"
                                ].map((item, i) => (
                                    <div className="col-sm-6" key={i}>
                                        <div className="check-item">
                                            <i className="fa-solid fa-circle-check"></i>
                                            <span>{item}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Professional Contact Card */}
                            <div className="profile-contact-card shadow-sm p-4 rounded-4">
                                <div className="row align-items-center">
                                    <div className="col-sm-6 border-end-sm">
                                        <div className="d-flex align-items-center gap-3">
                                            <img src={images.profile} alt="Swapnil Harale" className="founder-img" />
                                            <div>
                                                <h5 className="mb-0 fw-bold">Swapnil Harale</h5>
                                                <small className="text-muted">CEO & Founder</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 ps-sm-4 mt-3 mt-sm-0">
                                        <a href="tel:+918421367454" className="text-decoration-none">
                                            <div className="d-flex align-items-center gap-3 call-action">
                                                <div className="icon-circle">
                                                    <i className="bi bi-telephone-fill"></i>
                                                </div>
                                                <div>
                                                    <small className="text-muted d-block">Available 24/7</small>
                                                    <span className="fw-bold text-dark">+91 84213 67454</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}